import { t, tList } from "@travily/i18n";
import { Wizard } from "@ui/components/Wizard";
import type { ReactNode } from "react";
import { type AccountType, AccountTypeCard } from "@/components/AccountTypeCard/AccountTypeCard";

const FOUNDING_MEMBER_TYPES: AccountType[] = ["family", "community", "individual"];

export interface FoundingMemberCreatorShowViewProps {
  onSelectType: (type: AccountType) => void;
  /** Tertiary top-bar actions (Questions / Finish later). */
  topBarActions: ReactNode;
}

export function FoundingMemberCreatorShowView({ onSelectType, topBarActions }: FoundingMemberCreatorShowViewProps) {
  return (
    <Wizard color="green" contentMaxWidth="xlarge" currentStage={1} totalStages={1}>
      {topBarActions}
      <Wizard.Stage
        heading={t("web.founding_members.creator.show.title")}
        helper={t("web.founding_members.creator.show.subtitle")}
      >
        <div className="flex w-full flex-col items-center gap-6 lg:flex-row lg:items-stretch lg:justify-center">
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.family.title') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.family.subtitle') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.family.button') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.family.button_short') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.family.benefits') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.community.title') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.community.subtitle') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.community.button') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.community.button_short') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.community.benefits') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.individual.title') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.individual.subtitle') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.individual.button') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.individual.button_short') */}
          {/* i18n-tasks-use t('web.founding_members.creator.show.types.individual.benefits') */}
          {FOUNDING_MEMBER_TYPES.map((type) => (
            <AccountTypeCard
              key={type}
              type={type}
              title={t(`web.founding_members.creator.show.types.${type}.title`)}
              subtitle={t(`web.founding_members.creator.show.types.${type}.subtitle`)}
              items={tList(`web.founding_members.creator.show.types.${type}.benefits`)}
              buttonText={t(`web.founding_members.creator.show.types.${type}.button`)}
              buttonTextShort={t(`web.founding_members.creator.show.types.${type}.button_short`)}
              onPress={() => onSelectType(type)}
              className={type === "community" ? "mt-10 lg:mt-0" : ""}
            />
          ))}
        </div>
      </Wizard.Stage>
    </Wizard>
  );
}
